module.exports = __webpack_public_path__ + "media/images/ai-d7202173.svg";